/**
 * Providers Page
 */

import { Truck } from 'lucide-react'
import { CatalogPage } from './CatalogPage'
import { useTranslation } from '@/hooks/useTranslation'

export function ProvidersPage() {
  const { t } = useTranslation()

  return (
    <CatalogPage
      icon={Truck}
      config={{
        endpoint: 'providers',
        basePath: '/providers',
        title: t('catalogs.providers'),
        newItemLabel: t('catalogs.newProvider'),
        noItemsLabel: t('catalogs.noProviders'),
        displayField: 'name',
        secondaryField: 'contact_name',
        tertiaryField: 'identification',
        columns: [
          { key: 'name', header: t('clients.name') },
          { key: 'identification', header: t('clients.identification') },
          { key: 'contact_name', header: t('catalogs.contactName') },
          { key: 'phone', header: t('clients.phone') },
          { key: 'email', header: t('clients.email') },
        ],
      }}
    />
  )
}
